import { useCallback } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setCharacters } from "@/domains/account/slice";

export default function useGetCharacters() {
  const dispatch = useAppDispatch();

  const getCharacters = useCallback(async () => {
    const response = await AccountMpProvider.getCharacters();
    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setCharacters(response.data.characters));
    } else {
      console.log({ response });
    }
  }, [dispatch]);

  return { getCharacters };
}
